import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { logo } from 'Assets';
import * as Icon from 'Assets/icons';

export default function Sidebar(props) {
  const { navigation, dropDir, actions, user } = props;
  const location = useLocation();
  const [collapsedFooter, setCollapsedFooter] = useState(false);

  const collapseFooterEvent = () => setCollapsedFooter((prev) => !prev);

  let renderOptions = useMemo(() => {
    let mapOptions = (nav) => {
      let isSelected = location?.pathname?.match(nav?.path);

      if (nav.siblings?.length) {
        let isDropActive = nav.siblings
          .map((i) => i.path)
          .includes(location?.pathname);
        return (
          <div
            key={nav?.name}
            className={`nav-item drop  ${isDropActive ? 'drop--active' : ''}`}
            aria-expanded="true"
          >
            <button type="button" className="nav-item__header">
              <span className="nav-item__title">{nav?.name}</span>
              <i
                className={`fas fa-angle-${dropDir} nav-item__icon drop__icon--${dropDir}`}
              />
            </button>
            <div className={`drop__content drop__content--${dropDir}`}>
              {nav.siblings?.map(mapOptions)}
            </div>
          </div>
        );
      }

      return (
        <Link
          to={nav.path}
          className={`nav-item ${isSelected ? 'nav-item--active' : ''}`}
          key={nav.name}
        >
          <div className="nav-item__icon">
            {nav.name === 'Pipeline' ? <Icon.PipelineIcon /> : null}
            {nav.name === 'Transform' ? <Icon.TransformIcon /> : null}
            {nav.name === 'Visualize' ? <Icon.VisualizeIcon /> : null}
            {nav.name === 'Sandbox' ? <Icon.SandboxIcon /> : null}
            {nav.name === 'Add-ons' ? <Icon.AddonsIcon /> : null}
          </div>
          <span className="nav-item__title">{nav?.name}</span>
        </Link>
      );
    };
    return navigation?.map(mapOptions);
  }, [navigation, location, dropDir]);

  let renderActions = useMemo(() =>
    actions.map(
      (action) => (
        <li key={action.name}>
          <button
            type="button"
            className="sdp-btn sdp-btn--soft-ghost sdp-collapse-button"
            onClick={action.callback}
          >
            {action.name}
          </button>
        </li>
      ),
      [actions]
    )
  );

  let renderUserInfo = useMemo(() => {
    return (
      <>
        <div className="user-info">
          <Icon.UserIcon />
          <small>{user.name || 'loading...'}</small>
        </div>
      </>
    );
  }, [user]);

  return (
    <aside className="sdp-sidebar">
      <header className="sdp-sidebar__header">
        <div className="sdp-logo-wrapper">
          <img
            src={logo}
            className="logo-text"
            alt="Semantix Data Platform logo"
          />
        </div>
      </header>
      <nav className="sdp-sidebar__nav">{renderOptions}</nav>
      <footer className="sdp-sidebar__footer">
        <div className="footer-main-content">
          {renderUserInfo}
          <button
            type="button"
            className="sdp-btn sdp-btn--icon-only sdp-btn--soft-ghost sdp-collapse-button"
            onClick={collapseFooterEvent}
          >
            <i
              className={`fas fa-angle-${
                collapsedFooter ? 'down' : 'up'
              } footer-main-content__icon`}
            />
          </button>
        </div>
        <div
          className={`footer-aditional-nav collapse ${
            collapsedFooter ? 'show' : ''
          }`}
        >
          <ul>{renderActions}</ul>
        </div>
      </footer>
    </aside>
  );
}

Sidebar.propTypes = {
  navigation: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      path: PropTypes.string,
      siblings: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          path: PropTypes.string.isRequired
        })
      )
    })
  ),
  open: PropTypes.bool,
  toggle: PropTypes.bool,
  dropDir: PropTypes.oneOf(['down', 'right']),
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      callback: PropTypes.func
    })
  ),
  user: PropTypes.shape({
    name: PropTypes.string
  })
};

Sidebar.defaultProps = {
  navigation: [
    {
      name: 'default',
      path: '/default'
    }
  ],
  open: true,
  toggle: false,
  dropDir: 'down',
  actions: [{ name: 'sidebar', callback: () => null }],
  user: { name: 'Name' }
};
